// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomCard_card__fIwGz {

 display: flex;

 width: 22.7%;

 flex-direction: column;

 justify-content: space-between;

 border-radius: 12px;

 --tw-border-opacity: 1;

 border-color: rgb(234 236 240 / var(--tw-border-opacity));

 --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);

 --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);

 box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) /* Card Styling */
}

.CustomCard_heading__CteFX {

 font-family: Inter, sans-serif;

 font-size: 15px;

 font-weight: 600;

 line-height: 20px;

 letter-spacing: 0%;

 --tw-text-opacity: 1;

 color: rgb(255 255 255 / var(--tw-text-opacity))
}

.CustomCard_valueContainer__AKq5E {

 display: flex;

 align-items: center;

 justify-content: center;

 gap: 1.75rem;

 padding: 0.5rem
}

.CustomCard_valueContainer__AKq5E:hover {

 --tw-bg-opacity: 1;

 background-color: rgb(219 234 254 / var(--tw-bg-opacity))
}

.CustomCard_value__zDhOs {

 font-family: Inter, sans-serif;

 font-size: 30px;

 font-weight: 400;

 line-height: 38px;

 letter-spacing: 0%;

 --tw-text-opacity: 1;

 color: rgb(16 24 40 / var(--tw-text-opacity))
}

.CustomCard_customTag__K1YVh {

 display: flex;

 align-items: center;

 gap: 0px;

 border-radius: 9999px;

 --tw-border-opacity: 1;

 border-color: rgb(171 239 198 / var(--tw-border-opacity));

 --tw-bg-opacity: 1;

 background-color: rgb(236 253 243 / var(--tw-bg-opacity));

 padding-left: 0.5rem;

 padding-right: 0.5rem;

 padding-top: 0.25rem;

 padding-bottom: 0.25rem;

 font-size: 0.875rem;

 line-height: 1.25rem;

 font-weight: 500;

 --tw-text-opacity: 1;

 color: rgb(6 118 71 / var(--tw-text-opacity))
}`, "",{"version":3,"sources":["webpack://./src/components/Common/CustomCard/CustomCard.module.scss"],"names":[],"mappings":"AACI;;CAAA,aAAA;;CAAA,YAAA;;CAAA,sBAAA;;CAAA,8BAAA;;CAAA,mBAAA;;CAAA,sBAAA;;CAAA,yDAAA;;CAAA,+EAAA;;CAAA,mGAAA;;CAAA,sGAAA,EAAA,iBAAA;AAAA;;AAIA;;CAAA,8BAAA;;CAAA,eAAA;;CAAA,gBAAA;;CAAA,iBAAA;;CAAA,kBAAA;;CAAA,oBAAA;;CAAA;AAAA;;AAIA;;CAAA,aAAA;;CAAA,mBAAA;;CAAA,uBAAA;;CAAA,YAAA;;CAAA;AAAA;;AAAA;;CAAA,kBAAA;;CAAA;AAAA;;AAIA;;CAAA,8BAAA;;CAAA,eAAA;;CAAA,gBAAA;;CAAA,iBAAA;;CAAA,kBAAA;;CAAA,oBAAA;;CAAA;AAAA;;AAIA;;CAAA,aAAA;;CAAA,mBAAA;;CAAA,QAAA;;CAAA,qBAAA;;CAAA,sBAAA;;CAAA,yDAAA;;CAAA,kBAAA;;CAAA,yDAAA;;CAAA,oBAAA;;CAAA,qBAAA;;CAAA,oBAAA;;CAAA,uBAAA;;CAAA,mBAAA;;CAAA,oBAAA;;CAAA,gBAAA;;CAAA,oBAAA;;CAAA;AAAA","sourcesContent":[".card {\n    @apply  w-[22.7%] shadow-lg border-[#EAECF0] rounded-[12px] flex flex-col justify-between; /* Card Styling */\n  }\n  \n  .heading {\n    @apply text-[15px] font-semibold text-white font-inter leading-[20px] tracking-[0%];\n  }\n  \n  .valueContainer {\n    @apply flex justify-center items-center gap-7 p-2 hover:bg-blue-100;\n  }\n  \n  .value {\n    @apply text-[30px] font-normal text-[#101828] font-inter leading-[38px] tracking-[0%];\n  }\n  \n  .customTag {\n    @apply text-[#067647] font-medium bg-[#ECFDF3] rounded-full border-[#ABEFC6] flex items-center gap-0 px-2  py-1 text-sm ;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `CustomCard_card__fIwGz`,
	"heading": `CustomCard_heading__CteFX`,
	"valueContainer": `CustomCard_valueContainer__AKq5E`,
	"value": `CustomCard_value__zDhOs`,
	"customTag": `CustomCard_customTag__K1YVh`
};
export default ___CSS_LOADER_EXPORT___;
